import 'CssFolder/components/select-input-component.scss';
import { Icon, Icons, Intent } from "construct-ui";
import languageModel from "../../models/language.model";
import SelectSiteSearchInputDialog from "./select-site-search-input.dialog";

/**
 * Select Site Search Input Component
 * 
 * Input for validation and display in forms, onclick calls SelectSiteSearchInputDialog
 * 
 * @author Darrus Goh 
 */
export default function SelectSiteSearchInputComponent() {
    const TITLE_SEPARATOR = ', ';

    let isDialogOpen = false;

    const openDialog = () => {
        isDialogOpen = true;
    }

    const closeDialog = () => {
        isDialogOpen = false;
    }

    const renderLabel = (selectedItems) => {
        if (selectedItems?.length > 0) {
            if (selectedItems?.length <= 3) {
                return selectedItems.map(item => item.siteName).join(', ');
            } else {
                return selectedItems.length + ' ' + languageModel.getText("LT00000308", "items selected");
            }
        }

        return '';
    };

    const renderTitle = (selectedItems) => {
        if (selectedItems?.length > 0) {
            return selectedItems.map(item => item.siteName).join(TITLE_SEPARATOR);
        }

        return '';
    };

    const readOnly = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    return {
        view: ({ attrs: { id = '', disabled = false, selectedItems = [], selectedItem = null, multiple = false, onSelect, required = false, icon = Icons.LIST } }) => [
            m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
                class: disabled ? 'disabled ' : '',
                onclick: !disabled && openDialog
            },
                m('input.flex-fill.text-start.ps-0', {
                    id,
                    disabled,
                    required,
                    type: 'text',
                    placeholder: languageModel.getText('LT00000201', 'Please Select'),
                    oninput: readOnly,
                    autocomplete: 'off',
                    style: {
                        height: 'inherit',
                        'text-overflow': 'ellipsis',
                        border: 'none',
                        background: 'transparent'
                    },
                    value: renderLabel(multiple ? selectedItems : (selectedItem ? [selectedItem] : [])),
                    title: renderTitle(multiple ? selectedItems : (selectedItem ? [selectedItem] : []))
                }),
                m(Icon, { name: icon, intent: Intent.PRIMARY })
            ),
            m(SelectSiteSearchInputDialog,
                {
                    isOpen: isDialogOpen,
                    selectedItems,
                    selectedItem,
                    onSelect,
                    multiple,
                    onClose: closeDialog
                }
            )
        ]
    };
}